export default "__VITE_PUBLIC_ASSET__e03510b8__"